export const RECIPE_LIST = [
  {
    categoryId: '30',
    label: '人気メニュー',
  },
  {
    categoryId: '30-300',
    label: 'ハンバーグ',
  },
  {
    categoryId: '11',
    label: '魚',
  },
  {
    categoryId: '10-275',
    label: '牛肉',
  },
  {
    categoryId: '10-277',
    label: '鶏肉',
  },
  {
    categoryId: '30-307',
    label: 'カレー',
  },
  {
    categoryId: '30-304',
    label: '親子丼',
  },
  {
    categoryId: '20',
    label: 'お弁当',
  },
  {
    categoryId: '15',
    label: 'パスタ',
  },
  {
    categoryId: '14',
    label: 'ご飯もの',
  },
  {
    categoryId: '16',
    label: '麺料理',
  },
  {
    categoryId: '36',
    label: '時短料理',
  },
];
